/* eslint-disable @typescript-eslint/no-use-before-define */
import {
  ControlValueAccessor,
  FormControl,
  FormControlName,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import {
  Input,
  Component,
  forwardRef,
  HostListener,
  ViewChild,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
} from "@angular/core";
import { REGEX } from "../../../config/app.config";
import { EInputStyleType } from "../../../data-types/input-style.enum";
import { iconsLibrary } from "../../../../theme/constants";
@Component({
  selector: "cowing-input-dropdown",
  templateUrl: "./cowing-input-dropdown.component.html",
  styleUrls: ["./cowing-input-dropdown.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CowingInputDropdownComponent),
      multi: true,
    },
  ],
})
export class CowingInputDropdownComponent
  implements ControlValueAccessor, OnInit
{
  @HostListener("document:click", ["$event"])
  onClick(event) {}

  @Input("value") value: string;
  @Input("type") type: string = "text";
  @Input("inputStyle") inputStyle: string = EInputStyleType.Primary;
  @Input("iconShow") iconShow: boolean = false;
  @Input("iconName") iconName: string = "";
  @Input("label") label: string = "";
  @Input("placeholder") placeholder: string = "";
  @Input("required") required: boolean = false;
  @Input("validateInput") validateInput: boolean = true;
  @Input("options") options: Array<any> = [];
  @Input("isForm") isForm: boolean = false;
  @Input("control") control: FormControl = null;
  @Output("selectedValue") selectedValue = new EventEmitter();

  @ViewChild("input") input: ElementRef;
  keyboard: any;
  toggledShowPassword = false;
  valid = false;
  checked: boolean;
  msg = "";
  status = "";

  ngOnInit() {
    // console.log("HEYYYYY", this.control.value);
    if (this.isForm && this.control.value) {
      if (typeof this.control.value == "number") {
        const coincidence = this.options.find((opt) => {
          console.log(opt);
          return this.control.value == opt.id;
        });
        this.control.setValue(coincidence);
      } else {
        const coincidence = this.options.find((opt) => {
          const id = opt?.id || opt;
          console.log(id);
          return this.control.value == id;
        });
        console.log(coincidence, this.control.value);
        this.control.setValue(coincidence);
      }
    } else if (!this.isForm && this.options.length > 0) {
      this.selectedValue.emit(this.options[0]);
    }
  }
  private internalInputChange;
  constructor() {}
  public compareFn(c1: any, c2: any): boolean {
    if (c1 && c2 && c1.id && c2.id) {
      return c1 && c2 ? c1.id === c2.id : c1 === c2;
    } else {
      return c1 === c2;
    }
  }

  public newValue(value) {
    this.selectedValue.emit(value);
  }
  public onInputChange($event?: any) {
    if ($event) {
      this.value = $event.target.value;
      this.internalInputChange(this.value);
      this.validateFormat();
    }
  }

  public get getIcon() {
    return `${iconsLibrary[this.iconName]}`;
  }

  // toggleShowPassword() {
  //   this.toggledShowPassword = !this.toggledShowPassword;
  //   this.type = this.toggledShowPassword ? "text" : "password";
  // }

  writeValue(value: any): void {
    if (value) {
      this.value = value;
    }
  }
  registerOnChange(fn: any): void {
    this.internalInputChange = fn;
  }
  registerOnTouched(fn: any): void {
    //throw new Error("Method not implemented.");
  }
  setDisabledState?(isDisabled: boolean): void {
    // throw new Error("Method not implemented.");
  }

  onChangeKeyboard(input) {
    this.value = input;
    this.internalInputChange(this.value);
    this.validateFormat();
    console.log("Input changed", input);
  }

  onKeyPress(button) {
    console.log("Button pressed", button);
  }

  validateFormat() {
    if (this.required) {
      console.log("required", this.value);
      this.msg =
        this.value != "" && this.value != null
          ? ""
          : "common.validation.required";
      this.status = this.value != "" && this.value != null ? "" : "error";
      this.valid = this.value != "" && this.value != null ? true : false;
      this.checked = this.value != "" && this.value != null ? false : true;
    } else {
      this.valid = true;
    }
    if (this.valid) {
      if (this.type === "email") {
        this.checked = true;
        const regexMail: RegExp = REGEX.MAIL;
        this.valid = regexMail.test(this.value);
        if (this.valid) {
          this.msg = "common.validation.email.ok";
          this.status = "valid";
        } else {
          this.msg = "common.validation.email.error";
          this.status = "error";
        }
      } else if (this.type === "phone") {
        this.checked = true;
        const regexPhone: RegExp = REGEX.PHONE;
        this.valid = regexPhone.test(this.value);
        if (this.valid) {
          this.msg = "common.validation.phone.ok";
          this.status = "valid";
        } else {
          this.msg = "common.validation.phone.error";
          this.status = "error";
        }
      }
    }
  }
}
